import React from "react";
import "./functionaryCard.css";
const SERVER_UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL;

const FunctionaryCard = ({data, Fun}) => {
  const { email, name, position , photo, rank} = data;
  return (
    <div className="col-md-6 col-lg-3 pointer" onClick={()=>Fun(data)}>
      <article className="course">
        <div className="course-header">
          <img
            src={process.env.REACT_APP_UPLOADS_URL + photo}
            alt={name}
            className="rounded"
          />
        </div>
        <h3 className="course-title my-3 fs-5">{name}</h3>
        <div className="course-footer">
          <ul>
            <li>
              <i className="theme-clr me-1 fas fa-graduation-cap"></i>
              {rank}
            </li>
            <li>
              <i className="theme-clr me-1 fas fa-briefcase"></i>
              {position}
            </li>
          </ul>
          {/* <div className="footer-stars mt-2 d-flex">
            <span className="me-1 fw-bold">{phone}</span>
          </div> */}
        </div>
      </article>

      {/* <Certificate image={certificate} modal={show} /> */}
    </div>
  );
};

export default FunctionaryCard;
